"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import { useTheme as h } from "../../hooks.js";
import { useIsInverseVariant as l } from "../../theme-variant-context.js";
import { vars as i } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: t, size: e = 24 } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const n = l(), c = t !== null && t !== void 0 ? t : n ? i.colors.inverse : i.colors.neutralHigh, { skinName: a } = h();
    return a.match(/^o2-new/i) ? /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ o("path", {
            fill: c,
            d: "M8.004 2h6.344c1.945 0 3.528 1.605 3.524 3.576v12.853c0 1.97-1.58 3.571-3.524 3.571H8.004c-1.945 0-3.524-1.6-3.524-3.571V5.57C4.48 3.601 6.06 2 8.004 2M5.888 6.646v10.717h10.576V6.646zM8.004 3.43c-1.047 0-1.913.773-2.085 1.788h10.513c-.171-1.015-1.037-1.788-2.084-1.788zm0 17.147h6.344a2.12 2.12 0 0 0 2.084-1.788H5.92c.172 1.015 1.038 1.788 2.085 1.788m13.685-3.891a.7.7 0 0 1-.997.027.72.72 0 0 1-.027-1.01 5.32 5.32 0 0 0-.09-7.385.72.72 0 0 1 0-1.01.7.7 0 0 1 .997 0 6.745 6.745 0 0 1 .117 9.378m-2.166-1.454c.19 0 .38-.078.52-.234a4.37 4.37 0 0 0-.127-6.012.7.7 0 0 0-.997 0 .72.72 0 0 0 0 1.01 2.94 2.94 0 0 1 .085 4.038.72.72 0 0 0 .04 1.01.7.7 0 0 0 .48.188"
        })
    })) : /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ o("path", {
            fill: c,
            d: "M8.004 2h6.344c1.945 0 3.528 1.605 3.524 3.576v12.853c0 1.97-1.58 3.571-3.524 3.571H8.004c-1.945 0-3.524-1.6-3.524-3.571V5.57C4.48 3.601 6.06 2 8.004 2M5.888 6.646v10.717h10.576V6.646zM8.004 3.43c-1.047 0-1.913.773-2.085 1.788h10.513c-.171-1.015-1.037-1.788-2.084-1.788zm0 17.147h6.344a2.12 2.12 0 0 0 2.084-1.788H5.92c.172 1.015 1.038 1.788 2.085 1.788m13.685-3.891a.7.7 0 0 1-.997.027.72.72 0 0 1-.027-1.01 5.32 5.32 0 0 0-.09-7.385.72.72 0 0 1 0-1.01.7.7 0 0 1 .997 0 6.745 6.745 0 0 1 .117 9.378m-2.166-1.454c.19 0 .38-.078.52-.234a4.37 4.37 0 0 0-.127-6.012.7.7 0 0 0-.997 0 .72.72 0 0 0 0 1.01 2.94 2.94 0 0 1 .085 4.038.72.72 0 0 0 .04 1.01.7.7 0 0 0 .48.188"
        })
    }));
}, p = s;
export { p as default };
